import { createSlice } from "@reduxjs/toolkit";

interface TreeItemState {
  items: any[];
  selectedItem: any | null;
  selectedNode: string | null;
  expanded: string[];
  currentPath: any[];
  historyStack: any[];
  fetchItems: boolean;
}

const initialState: TreeItemState = {
  items: [],
  selectedItem: null,
  selectedNode: null,
  expanded: [],
  currentPath: [],
  historyStack: [],
  fetchItems: false,
};

const TreeItemSlice = createSlice({
  name: "treeItem",
  initialState,
  reducers: {
    setSelectedItem: (state, action) => {
      state.selectedItem = action.payload;
      localStorage.setItem("selected-item", JSON.stringify(action.payload));
    },
    setTreeItems: (state, action) => {
      state.historyStack = [...state.historyStack, state.items];
      if (state.historyStack.length > 10) {
        const tmp = [...state.historyStack];
        tmp.shift();
        state.historyStack = tmp;
      }
      state.items = action.payload;
      localStorage.setItem("tree-items", JSON.stringify(action.payload));
    },
    // setSelectedNode: (state, action) => {
    //   state.selectedNode = action.payload;
    //   localStorage.setItem("selected-node", JSON.stringify(action.payload));
    // },
    setExpanded: (state, action) => {
      state.expanded = action.payload;
      localStorage.setItem("tree-expanded", JSON.stringify(action.payload));
    },
    setCurrentPath: (state, action) => {
      state.currentPath = action.payload;
    },
    setFetchTreeItems: (state, action) => {
      state.fetchItems = action.payload;
    },
  },
});

export const {
  setSelectedItem,
  setTreeItems,
  setExpanded,
  setCurrentPath,
  setFetchTreeItems,
} = TreeItemSlice.actions;
export default TreeItemSlice.reducer;
